export const MIB = 1024 * 1024
export const GIB = 1024 * MIB

export const MULTIPART_THRESHOLD = 20 * MIB
export const PART_ALIGNMENT = 5 * MIB
export const MAX_PART_SIZE = 50 * MIB
export const MAX_PART_COUNT = 10000

function ceilDivide (dividend, divisor) {
  return Math.floor((dividend + divisor - 1) / divisor)
}

export function getMultipartPartSize (fileSize) {
  if (!Number.isSafeInteger(fileSize) || fileSize <= MULTIPART_THRESHOLD) {
    return null
  }
  if (fileSize <= 2 * GIB) {
    return 5 * MIB
  }
  if (fileSize <= 5 * GIB) {
    return 10 * MIB
  }
  if (fileSize <= 10 * GIB) {
    return 20 * MIB
  }

  const targetPartSize = ceilDivide(fileSize, 500)
  const alignedPartSize = ceilDivide(targetPartSize, PART_ALIGNMENT) * PART_ALIGNMENT
  return Math.min(alignedPartSize, MAX_PART_SIZE)
}

export function getMultipartPartPlan (fileSize) {
  const partSize = getMultipartPartSize(fileSize)
  if (partSize === null) {
    return null
  }

  const partCount = ceilDivide(fileSize, partSize)
  if (partCount > MAX_PART_COUNT) {
    throw new Error('文件过大，分片数量超过 OSS 限制')
  }
  return { partSize, partCount }
}
